import { AppState } from '../../reducers/root.reducer';
import { createSelector } from 'reselect';

const demo = (state: AppState) => state.common.demographics;

const getDemographics = createSelector(demo, (demo) => demo);

const DemographicSelector = {
    getDemographics,
};

export default DemographicSelector;
